<template>
  <aside
    class="alice-sidebar"
    :class="`alice-sidebar--${variant}`"
    :aria-label="'Workspace navigation'"
  >
    <div v-if="variant === 'labeled'" class="alice-sidebar__heading">
      Workspace
    </div>

    <a
      v-for="item in items"
      :key="item.key"
      :href="item.to || '#'"
      class="alice-sidebar__item"
      :class="{ 'alice-sidebar__item--active': item.active }"
      :title="item.label"
      @click.prevent="onSelect(item)"
    >
      <Icon :name="item.icon" :size="20" />
      <template v-if="variant === 'labeled'">
        <span class="alice-sidebar__label">{{ item.label }}</span>
        <span v-if="item.count != null" class="alice-sidebar__count">{{
          item.count
        }}</span>
      </template>
    </a>

    <div class="alice-sidebar__spacer" aria-hidden="true"></div>

    <a
      v-for="item in bottomItems"
      :key="item.key"
      :href="item.to || '#'"
      class="alice-sidebar__item"
      :class="{ 'alice-sidebar__item--active': item.active }"
      :title="item.label"
      @click.prevent="onSelect(item)"
    >
      <Icon :name="item.icon" :size="20" />
      <template v-if="variant === 'labeled'">
        <span class="alice-sidebar__label">{{ item.label }}</span>
      </template>
    </a>
  </aside>
</template>

<script>
import Icon from "./Icon.vue";
import { sidebarItems } from "./sidebarNav";

export default {
  name: "AliceSidebar",
  components: { Icon },
  props: {
    variant: {
      type: String,
      default: "rail",
      validator: (v) => v === "rail" || v === "labeled",
    },
    activeKey: { type: String, default: "projects" },
  },
  computed: {
    // Which items show, per audience (team vs guest): see ./sidebarNav.js.
    nav() {
      return sidebarItems({
        isGuest: this.$store.getters.isGuest,
        activeKey: this.activeKey,
      });
    },
    items() {
      return this.nav.items;
    },
    bottomItems() {
      return this.nav.bottomItems;
    },
  },
  methods: {
    onSelect(item) {
      if (item.key === "guide") {
        this.$store.commit("setGuestIntroOpen", true);
        return;
      }
      if (item.to) this.$router.push(item.to);
    },
  },
};
</script>

<style scoped>
.alice-sidebar {
  background: var(--vp-white);
  border-right: 1px solid var(--border-hairline);
  flex-shrink: 0;
}
.alice-sidebar--rail {
  width: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
  gap: 4px;
}

.alice-sidebar__spacer {
  flex: 1;
}
.alice-sidebar--labeled {
  width: 220px;
  padding: 20px 0;
}

.alice-sidebar__heading {
  padding: 0 20px 12px;
  font-family: var(--font-ui);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--fg-3);
}

.alice-sidebar__item {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--fg-3);
  border-left: 3px solid transparent;
  margin-left: -3px;
  font-family: var(--font-ui);
  font-size: 14px;
  font-weight: 600;
  transition: background var(--dur-fast) var(--ease-hover),
    color var(--dur-fast) var(--ease-hover),
    transform var(--dur-press) var(--ease-out);
}
.alice-sidebar__item:active {
  transform: scale(0.98);
}
.alice-sidebar--rail .alice-sidebar__item {
  width: 40px;
  height: 40px;
  justify-content: center;
}
.alice-sidebar--labeled .alice-sidebar__item {
  gap: 12px;
  padding: 10px 20px;
  margin-left: 0;
}

.alice-sidebar__item:hover {
  color: var(--vp-black);
  background: var(--bg-muted);
}

.alice-sidebar__item--active,
.alice-sidebar__item--active:hover {
  color: var(--vp-black);
  background: var(--accent-20);
  border-left-color: var(--accent-100);
  font-weight: 700;
}

.alice-sidebar__label {
  flex: 1;
}
.alice-sidebar__count {
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-3);
}
</style>
